module.exports = __webpack_public_path__ + "assets/4b96c9795c419e341177101ab15bc322.mp3";